/* Local dependencies */
import {
  ResetUpdateUserForManagerError,
  UpdateUserForManagerActionTypes,
  UpdateUserForManagerError,
  UpdateUserForManagerInput,
  UpdateUserForManagerRequest,
  UpdateUserForManagerReset,
  UpdateUserForManagerSuccess,
} from './types';

export function updateUserForManager(input: UpdateUserForManagerInput): UpdateUserForManagerRequest {
  return {
    type: UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER,
    input,
  };
}

export function updateUserForManagerSuccess(): UpdateUserForManagerSuccess {
  return {
    type: UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER_SUCCESS,
  };
}

export function updateUserForManagerError(error: Error): UpdateUserForManagerError {
  return {
    type: UpdateUserForManagerActionTypes.UPDATE_USER_FOR_MANAGER_ERROR,
    error,
  };
}

export function resetUpdateUserForManagerError(): ResetUpdateUserForManagerError {
  return {
    type: UpdateUserForManagerActionTypes.RESET_ERROR,
  };
}

export function resetStateUserForManager(): UpdateUserForManagerReset {
  return {
    type: UpdateUserForManagerActionTypes.RESET_STATE_UPDATE_USER_FOR_MANAGER,
  };
}
